module.exports = __webpack_public_path__ + "img/Logo.9b916618.svg";